import type { IColumn } from 'types'

import { routes } from 'helpers/routes'
import { Breadcrumb } from 'recoils/atoms'

export const HEADERS: IColumn[] = [
  {
    key: 'no',
    label: 'common:header.no.label',
    sortable: false,
    width: 6,
    textAlign: 'left',
  },
  {
    key: 'code',
    label: 'sku:sku.column',
    sortable: true,
    width: 15,
    textAlign: 'left',
  },
  {
    key: 'name',
    label: 'sku:productName.column',
    sortable: true,
    width: 38,
    textAlign: 'left',
  },
  {
    key: 'brand',
    label: 'sku:brand.column',
    sortable: true,
    width: 15,
    textAlign: 'left',
  },
  {
    key: 'category',
    label: 'sku:category.column',
    sortable: true,
    width: 20,
    textAlign: 'left',
  },
  {
    key: 'isActive',
    label: 'common:header.status.label',
    sortable: true,
    width: 6,
    textAlign: 'left',
  },
]

export const HEADERS_LOADING: IColumn[] = [
  {
    key: 'no',
    label: 'common:header.no.label',
    sortable: false,
    width: 21,
    textAlign: 'left',
  },
  {
    key: 'name',
    label: 'sku:productName.column',
    sortable: true,
    width: 38,
    textAlign: 'left',
  },
  {
    key: 'brand',
    label: 'sku:brand.column',
    sortable: true,
    width: 15,
    textAlign: 'left',
  },
  {
    key: 'category',
    label: 'sku:category.column',
    sortable: true,
    width: 26,
    textAlign: 'left',
  },
]

export const BREADCRUMBS_LIST: Breadcrumb[] = [
  { key: routes.product.path, label: 'layout:skuManagement.breadcrumb' },
]

export const BREADCRUMBS_CREATE: Breadcrumb[] = [
  { key: routes.product.path, label: 'layout:skuManagement.breadcrumb' },
  {
    key: routes.product.create.path,
    label: 'layout:createSKU.breadcrumb',
  },
]

export const renderBreadcrumbsEdit = (id: string): Breadcrumb[] => [
  { key: routes.product.path, label: 'layout:skuManagement.breadcrumb' },
  {
    key: `${routes.product.path}/${id}/detail`,
    label: 'layout:skuManagement.detail.breadcrumb',
  },
  {
    key: `${routes.product.path}/${id}/edit`,
    label: 'layout:editSKU.breadcrumb',
  },
]

export const renderBreadcrumbsDetail = (id: string): Breadcrumb[] => [
  { key: routes.product.path, label: 'layout:skuManagement.breadcrumb' },
  {
    key: `${routes.product.path}/${id}/detail`,
    label: 'layout:skuManagement.detail.breadcrumb',
  },
]

export const SKUTEMPLATE = 'skuImportTemplate'
